import { getWcBrand } from '../../../src/worldcup/helpers/wcBrand.helper';

/**
 * Blurb under the ticket title when the squad has no description of its own.
 *
 * Takes the competition's name rather than assuming the World Cup's: this waiting room serves
 * every competition's invite link, and a Champions League squad read "Predict every World Cup
 * match" (specs/champions-league Story 20). Falls back to the WC brand only when the server is
 * older than this field, which is also the only case where the link can only be a WC one.
 */
export const getWcInviteWaitingRoomSquadSubtitle = (competitionName?: string | null): string =>
  `Predict every ${competitionName?.trim() || getWcBrand().NAME} match. Climb the squad leaderboard.`;

export const WC_INVITE_WAITING_ROOM_COPY = {
  LOADING: 'Loading your squad...',
  ERROR_TITLE_FALLBACK: 'Invite not found',
  ERROR_MESSAGE: 'This invite may have expired or the code is incorrect.',
  GO_HOME_LABEL: 'Go to Zporti',
  CREATE_ACCOUNT_LABEL: 'Create Account & Join',
  CREATE_ACCOUNT_TEST_ID: 'wc-invite-create-account',
  SIGN_IN_LABEL: 'I already have an account',
  SIGN_IN_TEST_ID: 'wc-invite-sign-in',
  JOIN_NOW_LABEL: 'Join Squad',
  JOIN_NOW_TEST_ID: 'wc-invite-join-now',
  PRESENTED_BY_PREFIX: 'Presented by ',
  JOIN_TITLE_PREFIX: 'Join ',
} as const;
